import { Grid, Typography } from '@mui/material';
import React from 'react';

interface Props {
  title: string;
  buttons?: any;
  xs?: number;
  headlineVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export function PageHeader({ title, buttons, headlineVariant }: Props) {
  return (
    <Grid container spacing={2}>
      <Grid item flex={1}>
        <Typography variant={headlineVariant || 'h4'}>{title}</Typography>
      </Grid>
      <Grid item>
        {buttons?.map((item: any, index: number) => (
          <React.Fragment key={index}>{item}</React.Fragment>
        ))}
      </Grid>
    </Grid>
  );
}
